module.exports = function (app, mod) {
  var mobile = app.browser.isMobileBrowser() || window.innerWidth < 600;
  return "<div id=\"chat-manager-overlay\" class=\"chat-manager-overlay ".concat(mobile ? ' static-mobile-overlay' : ' floating-cm-overlay', "\"></div>");
};